let url = new Object()
const name = `promocodes`

const common = `/api/${name}/`
url.common = {
}

const adminUrl = `/api/${name}/admin/`
url.admin = {
  getAll: `${adminUrl}getall`,
  getOne: `${adminUrl}getOne`,
  add: `${adminUrl}add`,
  delete: `${adminUrl}delete`
}

const dealerUrl = `/api/${name}/dealer/`
url.dealer = {
  getAll: `${dealerUrl}getall`,
  getOne: `${dealerUrl}getOne`,
  add: `${dealerUrl}add`,
  delete: `${dealerUrl}delete`
}

export default url
